export default __webpack_public_path__ + "static/media/avatar.2c55e49d.png";